import script from "./ConferenceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceForm.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceForm.vue?vue&type=style&index=0&id=8b11ed88&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b11ed88"]])

export default __exports__